import { client } from "api";

export type DeletePhotoCommentRequest = { commentId: string };
export type DeletePhotoCommentResponse = string;

export const deletePhotoComment = ({ commentId }: DeletePhotoCommentRequest) =>
  client
    .delete<DeletePhotoCommentResponse>(`/bin/delete-photo-comment`, { data: { id: commentId } })
    .then((res) => res.data);
